import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import css from 'styled-jsx/css';
import StarRating from 'components/Shared/StarRating';
import { colors } from 'components/styles/variables';

// use locally resolvable styles and pass them into the StarRating component,
// so instead of starWidth it would use starClassName

/* istanbul ignore next */
const { styles: starCssStyles, className: starCssClassName } = css.resolve`
  div.star {
    width: 24px;
    height: 24px;
    background-size: 25px 23px;
    margin-left: 5px;
  }
`;

export default function OverallRating({ rating, count }) {
  const { t } = useTranslation();

  const basedOnNumRatingsKey =
    count === 1 ? 'basedOnNumRatingsSingular' : 'basedOnNumRatingsPlural';

  return (
    <div className="overall-rating-container">
      <StarRating value={rating} className={starCssClassName} />
      <div className="experience-label">{t('dealerPages.overallRating')}</div>
      <div className="experience-sub-label">
        {t(`dealerPages.${basedOnNumRatingsKey}`, { numReviews: count })}
      </div>
      {starCssStyles}
      <style jsx>{`
        .experience-label {
          font-size: 15px;
          font-weight: 900;
          text-transform: uppercase;
          padding-top: 7px;
        }

        .experience-sub-label {
          font-size: 14px;
          font-weight: 900;
          color: ${colors.G3};
        }
      `}</style>
    </div>
  );
}

OverallRating.propTypes = {
  rating: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
};
